<script setup lang="ts">
import type { SelectContentEmits, SelectContentProps } from 'reka-ui'

import { cn } from 'cn'
import { computed, type HTMLAttributes } from 'vue'
import { SelectContent, SelectPortal, SelectViewport, useForwardPropsEmits } from 'reka-ui'

import { selectContentVariants } from './variants'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(
  defineProps<SelectContentProps & { class?: HTMLAttributes['class'] }>(),
  {
    position: 'popper',
  },
)
const emits = defineEmits<SelectContentEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <SelectPortal>
    <SelectContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="cn(
        selectContentVariants({ position }),
        props.class,
      )
      "
    >
      <UiSelectScrollUpButton />
      <SelectViewport
        :class="cn(
          position === 'popper' && 'h-[--reka-select-trigger-height] w-full min-w-[--reka-select-trigger-width]',
        )"
      >
        <slot />
      </SelectViewport>
      <UiSelectScrollDownButton />
    </SelectContent>
  </SelectPortal>
</template>
